import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";

// Date format: mm/dd/yyyy hh: mm
const handleDateFormat = (time) => {

  if (time == null) {
    return;
  }

  let date = new Date(time);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  //let dateFormat = month < 10 ? "0" + month : month + "/" + day < 10 ? "0" + day : day + "/" + year;
  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;

  return year + "-" + month + "-" + day;
}

const loadPSOOrgList = async (token) => {
  const body = {
    "orgType": "PSO",
    "orgStatus": "Active"
  };

  const url = "/api/org/getPsoVendorByStatus";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  })

  return res;

}

const loadFormInfo = async (ACTIONS, formInfoDispatch, handleSelectChange, handleInputTextChange, listValues, token) => {

  formInfoDispatch({
    type: ACTIONS.SET_INITIAL_DATA,
    data: '',
    loading: true
  })

  const body = {
    "orgType": "Vendor",
    "orgStatus": "Active"
  };

  var status = STATUSES.SUCCESS;

  const psoOrgList = await loadPSOOrgList(token);

  //console.log("print out pso org list", psoOrgList);

  const url = "/api/org/getPsoVendorByStatus";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then(res => {
    //console.log("getPsoVendorByStatus()", res);
    const selectedVendor = listValues.vendorListValues(res.data);
    const selectedPSOOrg = listValues.psoOrgListValues(psoOrgList.data);

    return {
      selectedVendor: selectedVendor,
      selectedPSOOrg: selectedPSOOrg
    }

  }).then((obj) => {
    var data = {
      selectedPSOOrg: {
        value: '',
        options: obj.selectedPSOOrg,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleSelectChange,
        disabled: false,
        readOnly: false,
      },
      selectedVendor: {
        value: '',
        options: obj.selectedVendor,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleSelectChange,
        disabled: false,
        readOnly: false,
      },
      startDate: {
        value: '',
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      },
      endDate: {
        value: '',
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      }
    }

    formInfoDispatch({
      type: ACTIONS.SET_INITIAL_DATA,
      data: data,
      loading: false
    })
  }).catch(function (error) {
    //console.log("getPsoVendorByStatus()", error);
    status = STATUSES.ERROR;
    return Promise.reject({ status: status, data: error });
  });
};

const getEditVendorData = async (ACTIONS, formInfoDispatch, handleInputTextChange, token, vaId) => {

  formInfoDispatch({
    type: ACTIONS.SET_INITIAL_DATA,
    data: '',
    loading: true
  });


  const url = "/api/organization/vendor-authorization/view";
  const body = { "vaId": vaId };

  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {
    //console.log("print out getEditVendorData", res, res.data.startDate);
    var data = {
      startDate: {
        // value format for  react bootstrap date input: "yyyy/MM/dd" 
        value: handleDateFormat(res.data.startDate),
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      },
      endDate: {
        // value format for  react bootstrap date input: "yyyy/MM/dd"
        value: handleDateFormat(res.data.endDate),
        validation: {
          required: false,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      }
    }

    formInfoDispatch({
      type: ACTIONS.SET_INITIAL_DATA,
      data: data,
      loading: false
    })
  }).catch(function (error) {
    //console.log("getPsoVendorByStatus()", error);
  });



}

const submitAddVendorAuth = async (token, orgId, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue) => {

  clearErrorMessages(formInfo.data);

  //console.log("submitAddVendorAuth()");

  var request = {
    vaBean: {
      agreementId: null,
      //organizationId: orgId,
      organizationId: getFieldValue("selectedPSOOrg", formInfo.data),
      vendorOrganizationId: getFieldValue("selectedVendor", formInfo.data),
      startDate: getFieldValue("startDate", formInfo.data),
      endDate: getFieldValue("endDate", formInfo.data)
    },
    action: "Add"
  }
  //console.log("submitAddVendorAuth() request", request);
  var url = "/api/organization/vendor-authorization/save";

  var status = STATUSES.SUCCESS;

  const res = await http.post(url, request, {
    headers: {
      "Authorization": token
    }
  }).then(res => {
    var x = 0;
    var isFirst = false;
    for (const [key, value] of Object.entries(nameConverter)) {
      //console.log(`Key: ${key}, Value: ${value}`);

      var d = res.fieldErrors;
      var values = d[key];

      if (values != null) {
        if (x == 0) {
          isFirst = true;
        }
        else {
          isFirst = false;
        }
        addErrorMessages(value, key, res, isFirst);
        status = STATUSES.ERROR;
        x = x + 1;
      }
    }

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    //console.log("error caught from submitAddVendorAuth()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};


const submitEditVendorAuth = async (token, passedData, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue) => {

  clearErrorMessages(formInfo.data);

  //console.log("submitAddVendorAuth()");

  var request = {
    vaBean: {
      agreementId: passedData.id,
      organizationId: passedData.orgId,
      vendorOrganizationId: passedData.vendorOrganizationId,
      startDate: getFieldValue("startDate", formInfo.data),
      endDate: getFieldValue("endDate", formInfo.data)
    },
    action: "Update"
  }

  var url = "/api/organization/vendor-authorization/save";

  var status = STATUSES.SUCCESS;

  const res = await http.post(url, request, {
    headers: {
      "Authorization": token
    }
  }).then(res => {
    //console.log("submitEditVendorAuth()", res);
    var x = 0;
    var isFirst = false;
    for (const [key, value] of Object.entries(nameConverter)) {
      //console.log(`Key: ${key}, Value: ${value}`);

      var d = res.fieldErrors;
      var values = d[key];

      if (values != null) {
        if (x == 0) {
          isFirst = true;
        }
        else {
          isFirst = false;
        }
        addErrorMessages(value, key, res, isFirst);
        status = STATUSES.ERROR;
        x = x + 1;
      }
    }

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    //console.log("error caught from submitEditVendorAuth()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};

const submitDeleteVendorAuth = async (token, orgId, vaId) => {

  var request = {

    vendorAuthId: vaId,
    orgId: orgId
  }
  //console.log("submitDeleteVendorAuth() request", request);
  var url = "/api/organization/vendor-authorization/delete";

  var status = STATUSES.SUCCESS;

  const res = await http.post(url, request, {
    headers: {
      "Authorization": token
    }
  }).then(res => {

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    //console.log("error caught from submitAddVendorAuth()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};



export { loadFormInfo, submitAddVendorAuth, getEditVendorData, submitEditVendorAuth, submitDeleteVendorAuth };